import { render, staticRenderFns } from "./VirReportEmail.vue?vue&type=template&id=047c8844"
import script from "./VirReportEmail.vue?vue&type=script&lang=js"
export * from "./VirReportEmail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports